/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Blood, BloodInterface } from "../Blood";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarderAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "NotAnAdmin",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "addresses",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "bulkMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_addr",
        type: "address",
      },
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newAdmin",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isAdmin",
        type: "bool",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trustedForwarder_",
        type: "address",
      },
    ],
    name: "setForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b50604051620016e7380380620016e783398101604081905262000034916200022e565b604080518082018252600981526811d85dd9109b1bdbd960ba1b602080830191825283518085019094526005845264109313d3d160da1b90840152815184939162000083916003919062000188565b5080516200009990600490602084019062000188565b505050620000b6620000b0620000dd60201b60201c565b620000f9565b600680546001600160a01b0319166001600160a01b0392909216919091179055506200029d565b6000620000f46200014b60201b620009bf1760201c565b905090565b600580546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b6006546000906001600160a01b03163314156200016f575060131936013560601c90565b620000f46200018460201b620009ec1760201c565b3390565b828054620001969062000260565b90600052602060002090601f016020900481019282620001ba576000855562000205565b82601f10620001d557805160ff191683800117855562000205565b8280016001018555821562000205579182015b8281111562000205578251825591602001919060010190620001e8565b506200021392915062000217565b5090565b5b8082111562000213576000815560010162000218565b6000602082840312156200024157600080fd5b81516001600160a01b03811681146200025957600080fd5b9392505050565b600181811c908216806200027557607f821691505b602082108114156200029757634e487b7160e01b600052602260045260246000fd5b50919050565b61143a80620002ad6000396000f3fe6080604052600436106101405760003560e01c8063572b6c05116100b657806395d89b411161006f57806395d89b41146103b5578063a457c2d7146103ca578063a9059cbb146103ea578063b9998a241461040a578063dd62ed3e1461042a578063f2fde38b1461044a57600080fd5b8063572b6c05146102e05780636ae459bd1461030f57806370a0823114610322578063715018a61461035857806379cc67901461036d5780638da5cb5b1461038d57600080fd5b8063313ce56711610108578063313ce56714610218578063395093511461023457806340c10f191461025457806342966c6814610276578063486ff0cd146102965780634b0bddd2146102c057600080fd5b806306fdde0314610145578063095ea7b31461017057806318160ddd146101a057806323b872dd146101bf57806324d7806c146101df575b600080fd5b34801561015157600080fd5b5061015a61046a565b604051610167919061125e565b60405180910390f35b34801561017c57600080fd5b5061019061018b366004611154565b6104fc565b6040519015158152602001610167565b3480156101ac57600080fd5b506002545b604051908152602001610167565b3480156101cb57600080fd5b506101906101da3660046110dc565b61051e565b3480156101eb57600080fd5b506101906101fa366004611087565b6001600160a01b031660009081526007602052604090205460ff1690565b34801561022457600080fd5b5060405160128152602001610167565b34801561024057600080fd5b5061019061024f366004611154565b61054c565b34801561026057600080fd5b5061027461026f366004611154565b610578565b005b34801561028257600080fd5b50610274610291366004611245565b6105f5565b3480156102a257600080fd5b506040805180820190915260018152603160f81b602082015261015a565b3480156102cc57600080fd5b506102746102db366004611118565b610609565b3480156102ec57600080fd5b506101906102fb366004611087565b6006546001600160a01b0391821691161490565b61027461031d36600461117e565b610686565b34801561032e57600080fd5b506101b161033d366004611087565b6001600160a01b031660009081526020819052604090205490565b34801561036457600080fd5b50610274610754565b34801561037957600080fd5b50610274610388366004611154565b6107a9565b34801561039957600080fd5b506005546040516001600160a01b039091168152602001610167565b3480156103c157600080fd5b5061015a6107c5565b3480156103d657600080fd5b506101906103e5366004611154565b6107d4565b3480156103f657600080fd5b50610190610405366004611154565b61085a565b34801561041657600080fd5b50610274610425366004611087565b610872565b34801561043657600080fd5b506101b16104453660046110a9565b6108dd565b34801561045657600080fd5b50610274610465366004611087565b610908565b6060600380546104799061136c565b80601f01602080910402602001604051908101604052809291908181526020018280546104a59061136c565b80156104f25780601f106104c7576101008083540402835291602001916104f2565b820191906000526020600020905b8154815290600101906020018083116104d557829003601f168201915b5050505050905090565b6000806105076109f0565b90506105148185856109fa565b5060019392505050565b6000806105296109f0565b9050610536858285610b1e565b610541858585610b98565b506001949350505050565b6000806105576109f0565b905061051481858561056985896108dd565b610573919061133d565b6109fa565b6005546001600160a01b031661058c6109f0565b6001600160a01b0316141580156105c95750600760006105aa6109f0565b6001600160a01b0316815260208101919091526040016000205460ff16155b156105e7576040516355098f2760e01b815260040160405180910390fd5b6105f18282610d66565b5050565b6106066106006109f0565b82610d70565b50565b6106116109f0565b6001600160a01b031661062c6005546001600160a01b031690565b6001600160a01b03161461065b5760405162461bcd60e51b8152600401610652906112b3565b60405180910390fd5b6001600160a01b03919091166000908152600760205260409020805460ff1916911515919091179055565b6005546001600160a01b031661069a6109f0565b6001600160a01b0316141580156106d75750600760006106b86109f0565b6001600160a01b0316815260208101919091526040016000205460ff16155b156106f5576040516355098f2760e01b815260040160405180910390fd5b60005b825181101561074f5761073d838281518110610716576107166113d8565b6020026020010151838381518110610730576107306113d8565b6020026020010151610d66565b80610747816113a7565b9150506106f8565b505050565b61075c6109f0565b6001600160a01b03166107776005546001600160a01b031690565b6001600160a01b03161461079d5760405162461bcd60e51b8152600401610652906112b3565b6107a76000610d7a565b565b6107bb826107b56109f0565b83610b1e565b6105f18282610d70565b6060600480546104799061136c565b6000806107df6109f0565b905060006107ed82866108dd565b90508381101561084d5760405162461bcd60e51b815260206004820152602560248201527f45524332303a2064656372656173656420616c6c6f77616e63652062656c6f77604482015264207a65726f60d81b6064820152608401610652565b61054182868684036109fa565b6000806108656109f0565b9050610514818585610b98565b61087a6109f0565b6001600160a01b03166108956005546001600160a01b031690565b6001600160a01b0316146108bb5760405162461bcd60e51b8152600401610652906112b3565b600680546001600160a01b0319166001600160a01b0392909216919091179055565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b6109106109f0565b6001600160a01b031661092b6005546001600160a01b031690565b6001600160a01b0316146109515760405162461bcd60e51b8152600401610652906112b3565b6001600160a01b0381166109b65760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b6064820152608401610652565b61060681610d7a565b6006546000906001600160a01b03163314156109e2575060131936013560601c90565b503390565b905090565b3390565b60006109e76109bf565b6001600160a01b038316610a5c5760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f206164646044820152637265737360e01b6064820152608401610652565b6001600160a01b038216610abd5760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f206164647265604482015261737360f01b6064820152608401610652565b6001600160a01b0383811660008181526001602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925910160405180910390a3505050565b6000610b2a84846108dd565b90506000198114610b925781811015610b855760405162461bcd60e51b815260206004820152601d60248201527f45524332303a20696e73756666696369656e7420616c6c6f77616e63650000006044820152606401610652565b610b9284848484036109fa565b50505050565b6001600160a01b038316610bfc5760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f206164604482015264647265737360d81b6064820152608401610652565b6001600160a01b038216610c5e5760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201526265737360e81b6064820152608401610652565b6001600160a01b03831660009081526020819052604090205481811015610cd65760405162461bcd60e51b815260206004820152602660248201527f45524332303a207472616e7366657220616d6f756e7420657863656564732062604482015265616c616e636560d01b6064820152608401610652565b6001600160a01b03808516600090815260208190526040808220858503905591851681529081208054849290610d0d90849061133d565b92505081905550826001600160a01b0316846001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef84604051610d5991815260200190565b60405180910390a3610b92565b6105f18282610dcc565b6105f18282610eab565b600580546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b6001600160a01b038216610e225760405162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f2061646472657373006044820152606401610652565b8060026000828254610e34919061133d565b90915550506001600160a01b03821660009081526020819052604081208054839290610e6190849061133d565b90915550506040518181526001600160a01b038316906000907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9060200160405180910390a35050565b6001600160a01b038216610f0b5760405162461bcd60e51b815260206004820152602160248201527f45524332303a206275726e2066726f6d20746865207a65726f206164647265736044820152607360f81b6064820152608401610652565b6001600160a01b03821660009081526020819052604090205481811015610f7f5760405162461bcd60e51b815260206004820152602260248201527f45524332303a206275726e20616d6f756e7420657863656564732062616c616e604482015261636560f01b6064820152608401610652565b6001600160a01b0383166000908152602081905260408120838303905560028054849290610fae908490611355565b90915550506040518281526000906001600160a01b038516907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9060200160405180910390a3505050565b80356001600160a01b038116811461101057600080fd5b919050565b600082601f83011261102657600080fd5b8135602061103b61103683611319565b6112e8565b80838252828201915082860187848660051b890101111561105b57600080fd5b60005b8581101561107a5781358452928401929084019060010161105e565b5090979650505050505050565b60006020828403121561109957600080fd5b6110a282610ff9565b9392505050565b600080604083850312156110bc57600080fd5b6110c583610ff9565b91506110d360208401610ff9565b90509250929050565b6000806000606084860312156110f157600080fd5b6110fa84610ff9565b925061110860208501610ff9565b9150604084013590509250925092565b6000806040838503121561112b57600080fd5b61113483610ff9565b91506020830135801515811461114957600080fd5b809150509250929050565b6000806040838503121561116757600080fd5b61117083610ff9565b946020939093013593505050565b6000806040838503121561119157600080fd5b823567ffffffffffffffff808211156111a957600080fd5b818501915085601f8301126111bd57600080fd5b813560206111cd61103683611319565b8083825282820191508286018a848660051b89010111156111ed57600080fd5b600096505b848710156112175761120381610ff9565b8352600196909601959183019183016111f2565b509650508601359250508082111561122e57600080fd5b5061123b85828601611015565b9150509250929050565b60006020828403121561125757600080fd5b5035919050565b600060208083528351808285015260005b8181101561128b5785810183015185820160400152820161126f565b8181111561129d576000604083870101525b50601f01601f1916929092016040019392505050565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b604051601f8201601f1916810167ffffffffffffffff81118282101715611311576113116113ee565b604052919050565b600067ffffffffffffffff821115611333576113336113ee565b5060051b60200190565b60008219821115611350576113506113c2565b500190565b600082821015611367576113676113c2565b500390565b600181811c9082168061138057607f821691505b602082108114156113a157634e487b7160e01b600052602260045260246000fd5b50919050565b60006000198214156113bb576113bb6113c2565b5060010190565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052603260045260246000fd5b634e487b7160e01b600052604160045260246000fdfea26469706673582212202c36e47db4e5f40f0cba3e6716cfe6b0c89a2855d2821d49df582cf7a0e88bdd64736f6c63430008070033";

type BloodConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BloodConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Blood__factory extends ContractFactory {
  constructor(...args: BloodConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Blood";
  }

  override deploy(
    forwarderAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Blood> {
    return super.deploy(forwarderAddress, overrides || {}) as Promise<Blood>;
  }
  override getDeployTransaction(
    forwarderAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(forwarderAddress, overrides || {});
  }
  override attach(address: string): Blood {
    return super.attach(address) as Blood;
  }
  override connect(signer: Signer): Blood__factory {
    return super.connect(signer) as Blood__factory;
  }
  static readonly contractName: "Blood";

  public readonly contractName: "Blood";

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BloodInterface {
    return new utils.Interface(_abi) as BloodInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Blood {
    return new Contract(address, _abi, signerOrProvider) as Blood;
  }
}
